var _path, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnberg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 328 219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ee1d23",
    d: "M158 217c-1-4-1-5-4-6l-4-1v-13l-22 1-58 1h-2v13h-2l-20 1h-3v-14h-9a265 265 0 0 0-16 1v2c0 2-1 3-3 4l-9 1c-2 0-3-1-3-4l-2-6-1-6c0-4 1-7 5-8l2-2c1-2 2-2 9-2s8 0 10 3c2 2 3 2 9 2h4v-12a9347 9347 0 0 0-2-126l-1-12h66v-3l-1-6-3-1-4-1V13l14-1a100 100 0 0 0-1-11l18-1h51v7l2 76v3h4l6-1v-1c1-2 2-2 9-2h3a302 302 0 0 1 0 12v1l6-1h7c1 0 2-1 2-4l1-4 10-1h6a121 121 0 0 0 1-17 3715 3715 0 0 1 86-1l7 11c2 5 2 8 2 13s0 7-2 11c-1 4-2 6-6 9-2 3-3 3-5 4-5 3-9 3-33 4h-15v5l1 27 1 21h-4c-13 1-14 1-15 3v2l-3 2h-5l-4 1v8c0 7 0 8 2 9h2l2-1h3l4 1 1 4v3h-25v15h-69Z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 126,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: 34,
    fontWeight: 300,
    style: {
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "center"
    },
    textAnchor: "middle",
    transform: "translate(-1 -1)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 150,
    y: 126
  }, "Turnberg")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 150,
    y: 173
  }, "Building"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnberg);
export default __webpack_public_path__ + "static/media/Turnberg.ae1a89257c3e15d939db803cee864981.svg";
export { ForwardRef as ReactComponent };